const open = (trigger: HTMLElement, target: HTMLElement): void => {
  target.dataset.state = 'expanding';
  trigger.dataset.state = 'expanding';

  setTimeout(() => {
    target.dataset.state = 'expanded';
    trigger.dataset.state = 'expanded';
  }, 0);
};

const close = (trigger: HTMLElement, target: HTMLElement): void => {
  target.dataset.state = 'collapsing';
  trigger.dataset.state = 'collapsing';

  setTimeout(() => {
    target.dataset.state = 'collapsed';
    trigger.dataset.state = 'collapsed';
  }, 350);
};

export const initModal = (): void => {
  const triggers = document.querySelectorAll<HTMLElement>(
    '[data-toggle="modal"]',
  );

  triggers.forEach((trigger) => {
    const target = document.querySelector<HTMLElement>(
      `${trigger.dataset.target}`,
    );

    if (!target) {
      throw new Error('Modal trigger has no target');
    }

    trigger.addEventListener('click', () => {
      const isExpanded = target.dataset.state === 'expanded';

      if (isExpanded) {
        close(trigger, target);
      } else {
        open(trigger, target);
      }
    });

    // closing via dismiss button

    const dismisser = target.querySelector<HTMLElement>(
      '[data-dismiss="modal"]',
    );

    if (!dismisser) {
      return;
    }

    dismisser.addEventListener('click', () => close(trigger, target));

    // closing by clicking outside

    target.addEventListener('click', (e) => {
      if (e.target !== target) {
        return;
      }
      close(trigger, target);
    });
  });
};
